import axios from 'services/axios'
import { encrypt } from 'helpers/hash'
import {
  API_REGISTER,
  API_REGISTER_CHECK_CODE,
  API_REGISTER_CHECK_REF,
} from 'constants/endpoints'

/**
 * Check ref
 *
 * @param {String} ref
 * @return {Object}
 */
export const checkRef = async (ref) => {
  try {
    const { code, message, data } = await axios.post(API_REGISTER_CHECK_REF, {
      registerCode: ref,
    })

    if (code === 'A200') {
      return data
    }

    throw { message }
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Verify lessor
 *
 * @param {Object} form
 * @return {Object}
 */
export const checkCode = async (form) => {
  try {
    const { code, data, ...res } = await axios.post(
      API_REGISTER_CHECK_CODE,
      form
    )

    if (code === 'A200') {
      return data
    }

    throw res
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Setup password
 *
 * @param {Object} form
 * @return {Object}
 */
export const register = async (form, email) => {
  try {
    const { code, data, ...res } = await axios.post(API_REGISTER, {
      email,
      data: encrypt({
        ...form,
        email,
      }),
    })

    if (code === 'A200') {
      return data
    }

    throw res
  } catch (error) {
    return Promise.reject(error)
  }
}
